import countries from "@/config/countries";

export const displayCountry = (countryInfo) => {
  return countries.find((item) => item.code === countryInfo)?.name;
};
